module.exports = __webpack_public_path__ + "img/展示图2.ce78ac4f.png";